import { reactive, toRefs, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { getEWPreviewDetailBySpuId } from '@/api/directSales'

export default function useShopDetail() {
  const store = useStore()
  const state = reactive({
    hasDealer: false,
    slideList: [],
    dblclickImage: [],
    detailData: {},
    currentSkuLis: [],
    isEnterShoppingCar: true,
    isEnable: false, //计划是否生效中--true
    selectShopVariantItem: {},
    skuItem: {}
  })
  // 获取详情信息
  const getShopDetailFn = async params => {
    if (!params.spuId) return
    store.commit('SETSPUID', params.spuId)
    const data = await getEWPreviewDetailBySpuId(params.spuId)
    data.skuList = data.skuList.map(sku => {
      return {
        ...sku,
        description: sku.description1,
        useDescription: sku.description2
      }
    })
    data.salesAttributes = data.salesAttributes.map(att => {
      return {
        ...att,
        values: att.values.map(value => {
          return {
            lable: value,
            code: value
          }
        })
      }
    })
    state.detailData = data
    state.isEnable = true
    state.slideList = data.banners
    state.dblclickImage = data.banners
    state.currentSkuLis = data.skuList
    const selectShopVariantItem = {}
    if (data?.uploadSkuCount === 1 && data.skuList?.length === 1) {
      for (let index = 0; index < data.salesAttributes.length; index++) {
        const item = data.salesAttributes[index]
        selectShopVariantItem[item.code] = { code: item.values[0].code, lable: item.values[0].lable, pName: item.name, pid: item.code }
      }
      store.commit('SETSkUITEM', { ...data.skuList[0] })
    } else {
      for (let index = 0; index < data.salesAttributes.length; index++) {
        const item = data.salesAttributes[index]
        selectShopVariantItem[item.code] = ''
      }
    }

    store.commit('SETSELECTSHOPVARIANTITEM', { ...selectShopVariantItem })
  }

  const salesAttributesTxt = computed(() => {
    const salesAttributes = state.detailData?.salesAttributes || []
    const customerAttributesName = salesAttributes
      .map(({ name, code }) => {
        let item = store.state.selectShopVariantItem[code]
        return item && item.pName ? `${item.pName}:${item.lable}` : name
      })
      .join('; ')
    return customerAttributesName
  })

  const shopInfoDatas = computed(() => ({
    ...state.detailData,
    isShowStep: state.isEnable,
    max: state.max,
    currentSkuLis: state.currentSkuLis
  }))

  watch(
    () => store.state.selectShopVariantItem,
    v => {
      const keys = Object.keys(v)
      state.selectShopVariantItem = v
      if (keys && keys.length && keys.length === state.detailData?.salesAttributes?.length) {
        const skuItem = state.currentSkuLis.find(sku => keys.map(attr => sku[attr] === v[attr]['code']).every(item => item === true)) || {}
        store.commit('SETSkUITEM', skuItem)
        state.skuItem = skuItem
      }
    },
    { deep: true }
  )

  return {
    ...toRefs(state),
    getShopDetailFn,
    salesAttributesTxt,
    shopInfoDatas
  }
}
